module.exports = __webpack_public_path__ + "static/powerbox-18fe4b812393314ee6b5580a060d45e1.jpg";